document.addEventListener('DOMContentLoaded', function () {

    const grid = document.querySelector('.LpSokolVideosGrid');
    const expandButton = document.querySelector('.LpSokolVideosExpandButton');

    if (!grid || !expandButton) return;

    // expand button
    expandButton.addEventListener('click', function () {
        grid.classList.add('LpSokolVideosGrid--expanded');
        expandButton.classList.add('d-none');
    });

    // stop the video when modal hides
    const $LpSokolVideoModal = $('.LpSokolVideoModal');

    $LpSokolVideoModal.on('hidden.bs.modal', function () {
        const $iframe = $(this).find('.LpSokolVideoIframe');
        const source = $iframe.attr('src');
        $iframe.attr('src', source);
    });

});